module.exports = __webpack_public_path__ + "img/U1F649.0e933eef.png";